import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import AssistanceEditCategoryModal from '../../components/assistance/AssistanceEditCategoryModal'
import { createCategory, removeCategory } from '../../state/actions/assistance/index'
import { IAssistanceCategoryObject, IStoreState } from '../../types/index'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    categories: Object.values(state.assistanceCategories.items),
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    onRemove: (category: IAssistanceCategoryObject) => {
      dispatch(removeCategory(category))
    },
    onCreate: (category: IAssistanceCategoryObject) => {
      dispatch(createCategory(category))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssistanceEditCategoryModal)



// WEBPACK FOOTER //
// ./src/containers/assistance/AssistanceEditCategoryModal.ts